<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="128px"
    height="128px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 128 128"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <defs>
      <!-- <style type="text/css">
   <![CDATA[
    .str0 {stroke:black;stroke-width:0.9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}
    .fil2 {fill:black}
    .fil0 {fill:black}
    .fil5 {fill:white}
    .fil1 {fill:black;fill-rule:nonzero}
    .fil3 {fill:black;fill-rule:nonzero}
    .fil4 {fill:white;fill-rule:nonzero}
   ]]>
  </style> -->
    </defs>
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M97.95 14.99c5.39,0 9.76,4.37 9.76,9.76 0,5.2 -4.06,9.44 -9.18,9.74l0 0.01 -0.08 0c-0.17,0.01 -0.33,0.01 -0.5,0.01 -0.17,0 -0.33,0 -0.5,-0.01l-42.81 0 0 0c-0.17,0.01 -0.33,0.01 -0.5,0.01 -5.39,0 -9.76,-4.37 -9.76,-9.76 0,-5.39 4.37,-9.76 9.76,-9.76l0.06 0c0.71,-8.4 7.75,-14.99 16.33,-14.99 5.29,0 10,2.52 13,6.42 1.39,-0.76 2.98,-1.19 4.66,-1.19 5.39,0 9.76,4.37 9.76,9.76zm-43.84 5c-2.62,0.02 -4.73,2.14 -4.73,4.76 0,2.63 2.13,4.76 4.76,4.76 0.08,0 0.17,0 0.25,-0.01 0.09,0 0.16,0 0.25,0l42.81 0c0.09,0 0.17,0 0.25,0 0.09,0.01 0.17,0.01 0.25,0.01 0.08,0 0.15,0 0.23,0 0.02,-0.01 0.04,-0.01 0.06,-0.01 2.51,-0.15 4.47,-2.23 4.47,-4.75 0,-2.63 -2.13,-4.76 -4.76,-4.76 -2.75,0 -5,-2.24 -5,-5 0,-2.63 -2.13,-4.76 -4.76,-4.76 -0.79,0 -1.57,0.2 -2.27,0.58 -2.17,1.19 -4.84,0.62 -6.35,-1.35 -2.17,-2.82 -5.48,-4.46 -9.04,-4.46 -5.91,0 -10.85,4.53 -11.35,10.41 -0.22,2.62 -2.42,4.62 -5.05,4.58l-0.02 0z"
      />
      <path
        class="fil1"
        d="M40.35 13.65c1.1,0 2,0.9 2,2 0,1.11 -0.9,2 -2,2l-16.91 0 0 24.43c0,1.1 -0.9,2 -2,2 -1.1,0 -2,-0.9 -2,-2l0 -26.43c0,-1.1 0.9,-2 2,-2l18.91 0z"
      />
      <path
        class="fil1"
        d="M41.62 112.29c1.1,0.01 1.99,0.91 1.98,2.01 0,1.1 -0.9,1.98 -2,1.98l-21.42 -0.1c-1.1,0 -1.99,-0.9 -1.99,-1.99l-0.01 -27.74c0,-1.1 0.9,-2 2,-2 1.11,0 2,0.9 2,2l0 25.75 19.44 0.09z"
      />
      <path
        class="fil0"
        d="M128 98.51l0 3.1 -45.24 26.39 -44.57 -26.42 0 -3.07c13.47,-7.68 25.59,-15.36 38.56,-23.06l1.13 0.58 -37.68 22.49 42.56 24.75 43.3 -24.8 -35.91 -23.69 0.97 -0.57 36.88 24.3z"
      />
      <polygon
        class="fil2"
        points="66.87,106.31 66.66,106.17 66.93,105.75 77.59,112.43 77.32,112.85 "
      />
      <path
        class="fil3"
        d="M74.04 97.09c0,-0.14 0.11,-0.25 0.25,-0.25 0.14,0 0.25,0.11 0.25,0.25l0 13.49c0,0.14 -0.11,0.25 -0.25,0.25 -0.14,0 -0.25,-0.11 -0.25,-0.25l0 -13.49z"
      />
      <path
        class="fil3"
        d="M70.51 95.89c0,-0.14 0.12,-0.25 0.26,-0.25 0.13,0 0.25,0.11 0.25,0.25l0 12.4c0,0.14 -0.12,0.25 -0.25,0.25 -0.14,0 -0.26,-0.11 -0.26,-0.25l0 -12.4z"
      />
      <polygon
        class="fil0"
        points="83.1,81.26 83.1,116.32 110.58,100.68 110.58,65.95 "
      />
      <path
        class="fil0"
        d="M110.58 65.95l-27.48 15.31 -22.69 -11.86 27.4 -15.95 22.77 12.5zm-27.38 12.85l-17.85 -9.27 22.11 -12.8 17.85 9.26 -22.11 12.81z"
      />
      <polygon
        class="fil0"
        points="83.1,81.26 60.42,69.4 60.41,82.74 83.1,94.7 "
      />
      <polygon
        class="fil0"
        points="65.12,93.66 58.67,90.39 58.67,93.92 58.67,103.37 65.22,107.28 "
      />
      <polygon
        class="fil0"
        points="65.12,93.66 65.22,107.28 67.01,106.1 67.01,94.61 "
      />
      <polygon
        class="fil0"
        points="83.1,102.76 77.25,99.8 77.25,112.8 83.1,116.32 "
      />
      <path
        class="fil4"
        d="M67.25 76.24l1.34 0.58 -0.36 4.47c-0.04,0.44 -0.11,0.83 -0.22,1.18 -0.12,0.35 -0.27,0.62 -0.46,0.82 -0.19,0.19 -0.38,0.3 -0.57,0.32 -0.26,0.02 -0.57,-0.06 -0.92,-0.25 -0.19,-0.11 -0.41,-0.25 -0.63,-0.42 -0.23,-0.18 -0.41,-0.38 -0.55,-0.6 -0.15,-0.22 -0.27,-0.5 -0.38,-0.83 -0.1,-0.32 -0.17,-0.63 -0.19,-0.94 -0.04,-0.48 -0.05,-0.89 -0.03,-1.24l0.31 -4.23 1.23 0.53 -0.33 4.41c-0.03,0.39 0.01,0.72 0.12,1 0.1,0.29 0.26,0.48 0.48,0.6 0.22,0.11 0.4,0.09 0.54,-0.06 0.15,-0.16 0.23,-0.44 0.27,-0.84l0.35 -4.5zm2.27 0.98l2.75 1.17c0.48,0.21 0.84,0.56 1.06,1.06 0.23,0.5 0.32,1.04 0.26,1.61 -0.04,0.47 -0.18,0.84 -0.4,1.08 -0.14,0.17 -0.34,0.26 -0.58,0.28 0.34,0.31 0.58,0.67 0.72,1.09 0.14,0.42 0.19,0.88 0.14,1.39 -0.04,0.41 -0.13,0.75 -0.29,1.01 -0.15,0.26 -0.34,0.43 -0.56,0.51 -0.14,0.04 -0.34,0.02 -0.6,-0.06 -0.35,-0.11 -0.57,-0.2 -0.68,-0.26l-2.46 -1.33 0.64 -7.55zm1.18 3.67l0.65 0.31c0.23,0.11 0.4,0.12 0.5,0.03 0.1,-0.09 0.17,-0.25 0.19,-0.5 0.02,-0.23 -0.01,-0.43 -0.09,-0.6 -0.08,-0.18 -0.23,-0.31 -0.46,-0.42l-0.66 -0.29 -0.13 1.47zm-0.26 3.01l0.74 0.39c0.26,0.13 0.44,0.15 0.56,0.06 0.12,-0.09 0.19,-0.26 0.22,-0.51 0.02,-0.23 -0.02,-0.44 -0.11,-0.63 -0.09,-0.2 -0.27,-0.36 -0.53,-0.49l-0.74 -0.36 -0.14 1.54zm3.62 0.91l1.56 0.63c-0.01,0.41 0.03,0.74 0.12,0.99 0.14,0.42 0.37,0.71 0.69,0.88 0.24,0.13 0.44,0.14 0.59,0.04 0.15,-0.1 0.24,-0.27 0.27,-0.49 0.02,-0.22 -0.02,-0.44 -0.13,-0.68 -0.11,-0.23 -0.39,-0.53 -0.83,-0.91 -0.71,-0.62 -1.2,-1.2 -1.46,-1.76 -0.27,-0.56 -0.37,-1.15 -0.31,-1.79 0.04,-0.41 0.16,-0.77 0.35,-1.08 0.2,-0.31 0.47,-0.5 0.81,-0.57 0.35,-0.08 0.82,0 1.4,0.25 0.73,0.31 1.27,0.76 1.62,1.34 0.35,0.58 0.51,1.34 0.49,2.27l-1.7 -0.63c-0.01,-0.41 -0.07,-0.73 -0.19,-0.97 -0.12,-0.23 -0.31,-0.41 -0.55,-0.52 -0.2,-0.08 -0.36,-0.09 -0.47,-0.01 -0.11,0.08 -0.18,0.22 -0.2,0.4 -0.01,0.13 0.02,0.27 0.09,0.41 0.06,0.15 0.24,0.34 0.54,0.57 0.73,0.6 1.25,1.11 1.56,1.52 0.32,0.42 0.53,0.85 0.65,1.3 0.11,0.46 0.14,0.92 0.09,1.38 -0.06,0.54 -0.22,0.99 -0.47,1.34 -0.26,0.34 -0.58,0.53 -0.97,0.57 -0.38,0.04 -0.84,-0.09 -1.37,-0.38 -0.92,-0.5 -1.51,-1.1 -1.8,-1.81 -0.29,-0.7 -0.42,-1.46 -0.38,-2.29z"
      />
      <g id="_2083602062816">
        <g>
          <polygon
            class="fil5 str0"
            points="90.33,82.84 93.21,80.99 93.21,88.73 90.33,90.02 "
          />
          <polygon
            class="fil5 str0"
            points="90.33,90.33 93.21,89.03 93.21,97.13 90.33,98.42 "
          />
          <polygon
            class="fil5 str0"
            points="90.33,98.79 93.21,97.5 93.21,105.59 90.33,106.89 "
          />
        </g>
        <g>
          <polygon
            class="fil5 str0"
            points="96,79.65 98.88,77.79 98.88,85.53 96,86.83 "
          />
          <polygon
            class="fil5 str0"
            points="96,87.14 98.88,85.84 98.88,93.93 96,95.23 "
          />
          <polygon
            class="fil5 str0"
            points="96,95.6 98.88,94.31 98.88,102.4 96,103.69 "
          />
        </g>
        <g>
          <polygon
            class="fil5 str0"
            points="101.66,76.46 104.54,74.6 104.54,82.34 101.66,83.64 "
          />
          <polygon
            class="fil5 str0"
            points="101.66,83.94 104.54,82.65 104.54,90.74 101.66,92.03 "
          />
          <polygon
            class="fil5 str0"
            points="101.66,92.41 104.54,91.11 104.54,99.2 101.66,100.5 "
          />
        </g>
      </g>
      <polygon
        class="fil0"
        points="58.67,90.39 58.67,84.04 60.41,82.74 83.1,94.7 83.1,102.76 "
      />
      <polygon
        class="fil5"
        points="83.1,94.7 83.1,97.1 58.67,84.03 60.41,82.74 "
      />
      <g id="_2083602060128">
        <g>
          <path
            id="path562"
            class="fil0"
            d="M73.74 20.86l-0.91 -0.26c-0.59,-0.19 -0.99,-0.75 -0.99,-1.36 0,-0.81 0.64,-1.44 1.44,-1.44l1.79 0 0 0.63 -1.25 0c-0.25,0 -0.46,0.19 -0.46,0.46 0,0.16 0.11,0.35 0.3,0.4l0.87 0.29c0.62,0.19 0.94,0.8 0.94,1.49 0,0.88 -0.72,1.6 -1.6,1.6l-1.9 0 0 -0.72 1.63 0c0.24,0 0.51,-0.23 0.51,-0.55 0,-0.25 -0.14,-0.46 -0.37,-0.54l0 0zm-8.33 0l-0.9 -0.26c-0.56,-0.19 -0.96,-0.75 -0.96,-1.36 0,-0.81 0.64,-1.44 1.44,-1.44l1.79 0 0 0.63 -1.26 0c-0.24,0 -0.45,0.19 -0.45,0.46 0,0.16 0.11,0.35 0.29,0.4l0.88 0.29c0.59,0.19 0.91,0.8 0.91,1.49 0,0.88 -0.69,1.6 -1.57,1.6l-1.89 0 0 -0.72 1.62 0c0.24,0 0.51,-0.23 0.51,-0.55 0,-0.25 -0.16,-0.46 -0.41,-0.54l0 0zm4.14 1.98c-1.09,0 -1.95,-0.78 -1.95,-1.74l0 -3.27 1.47 0 0 3.41c0,0.42 0.37,0.77 0.85,0.77 0.45,0 0.86,-0.35 0.86,-0.77l0 -3.41 0.69 0 0 3.27c0,0.96 -0.85,1.74 -1.92,1.74z"
            inkscape:connector-curvature="0"
            inkscape:export-filename="C:\Users\suitedoalex\sites\sus-logo-1.png"
            inkscape:export-xdpi="218.00664"
            inkscape:export-ydpi="218.00664"
          />
        </g>
        <g>
          <path
            id="path564"
            class="fil0"
            d="M84.19 22.8c0,0 -2.07,0.14 -3.83,-0.02 0.04,2.14 0.29,3.24 0.34,3.48l3.84 0c-0.18,-1.13 -0.33,-2.95 -0.35,-3.46l0 0zm-6.52 -4.44c0.25,0.02 2.52,0.22 2.67,0.22l3.59 3.65 4.61 0 0 -3.87 -10.87 0zm3 -0.23l3.87 0 0 -3.75 -3.87 0 0 3.75zm-0.03 1.08l0 0 -0.5 -0.51c-0.67,0.01 -2.83,-0.22 -3.52,-0.34l0 3.87c3.46,0.34 5.28,0.43 7.31,0.36l0.04 0 -3.33 -3.38zm3.53 3.21l0.47 0 0 3.01c-0.06,-0.31 -0.24,-2.14 -0.21,-2.73 -0.06,-0.06 -0.26,-0.28 -0.26,-0.28z"
            inkscape:connector-curvature="0"
            inkscape:export-filename="C:\Users\suitedoalex\sites\sus-logo-1.png"
            inkscape:export-xdpi="218.00664"
            inkscape:export-ydpi="218.00664"
          />
        </g>
      </g>
      <path
        class="fil0"
        d="M23.13 75.36l20.76 0c0,1.24 -0.74,2.48 -2.63,2.48l-18.13 0 -18.13 0c-1.89,0 -2.64,-1.24 -2.64,-2.48l20.77 0zm-13.51 -27.82l27.02 0c2.62,0 4.77,2.14 4.77,4.76l0 20.77 -2.1 0 0 -21.07c0,-1.21 -0.99,-2.2 -2.2,-2.2l-27.97 0c-1.2,0 -2.19,0.99 -2.19,2.2l0 21.07 -2.1 0 0 -20.77c0,-2.62 2.15,-4.76 4.77,-4.76zm13.51 25.53l21.32 0c0.99,0 1.81,0.81 1.81,1.81 0,3.12 -3.14,5.26 -6.29,5.26l-16.84 0 -16.84 0c-3.15,0 -6.29,-2.14 -6.29,-5.26 0,-1 0.81,-1.81 1.81,-1.81l21.32 0z"
      />
      <g>
        <path
          class="fil0"
          d="M25.11 60.09l0.92 -0.01c0.01,0.39 0,0.78 0,1.17 0,0.39 -0.01,0.79 0.43,0.78 0.44,0 0.4,-0.38 0.4,-0.75 0,-0.4 0,-0.81 0.01,-1.2l0.91 0c0.01,0.44 0.05,1.62 -0.07,1.98 -0.16,0.52 -0.58,0.77 -1.25,0.77 -0.66,0.01 -1.12,-0.23 -1.28,-0.76 -0.12,-0.37 -0.08,-1.53 -0.07,-1.98zm4.86 0.91c-0.15,-0.05 -0.87,-0.49 -1.01,-0.14 0,0.2 0.72,0.16 1.15,0.43 0.35,0.21 0.51,0.74 0.2,1.13 -0.58,0.73 -2.16,0.34 -2.4,-0.06 0.09,-0.11 0.38,-0.44 0.43,-0.55 0.18,0.06 0.32,0.18 0.56,0.25 0.64,0.18 0.83,-0.09 0.47,-0.2 -0.11,-0.03 -0.21,-0.05 -0.32,-0.07 -0.2,-0.04 -0.42,-0.1 -0.59,-0.19 -0.76,-0.4 -0.53,-1.57 0.73,-1.57 0.46,0 0.97,0.12 1.2,0.38 -0.11,0.19 -0.29,0.39 -0.42,0.59zm-7.17 0.8c0.23,0.14 0.37,0.24 0.7,0.29 0.13,0.02 0.35,0.06 0.44,-0.02 0.34,-0.31 -1.23,-0.18 -1.44,-0.9 -0.19,-0.61 0.27,-1 0.75,-1.11 0.47,-0.1 1.36,0.04 1.57,0.35 -0.1,0.15 -0.31,0.47 -0.44,0.59 -0.14,-0.09 -0.85,-0.45 -1,-0.14 0.12,0.25 0.63,0.12 1.18,0.45 0.6,0.35 0.49,1.63 -1.05,1.51 -0.74,-0.05 -0.87,-0.28 -1.19,-0.42 0.07,-0.17 0.35,-0.44 0.48,-0.6zm-2.12 2.36c0.07,0.23 -0.09,0.3 -0.26,0.39 -2.97,1.6 -6.25,-0.61 -5.67,-3.78 0.62,-3.4 5.18,-3.92 6.76,-1.31 0.76,1.26 0.5,3.11 -0.95,3.9 -1.27,0.68 -3.26,0.78 -4.13,-0.58 -0.72,-1.12 -0.33,-3.2 1.39,-3.61 0.89,-0.21 1.73,0.05 2.21,0.5 0.43,0.41 0.77,1.35 0.64,2.21l-2.81 0.03c-0.01,0.53 0.37,0.89 0.76,1.04 0.97,0.38 3.17,-0.28 2.94,-2.28 -0.25,-2.17 -2.73,-3 -4.52,-2.27 -0.85,0.34 -1.47,0.98 -1.79,1.85 -0.68,1.81 0.24,4.02 2.45,4.43 1.8,0.34 2.62,-0.63 2.98,-0.52zm0.4 4.91l5.21 0 0.05 -0.01c0.15,-0.05 0.25,-0.06 0.39,-0.17 0.46,-0.35 0.33,-0.85 0.33,-1.56 0,-0.83 -0.02,-1.68 0,-2.5 0.71,-0.05 3.31,0.1 3.72,-0.07 0.21,-0.08 0.38,-0.27 0.46,-0.47 0.12,-0.32 0.06,-2.41 0.06,-2.83 0,-0.63 0,-1.26 0,-1.9 0,-0.71 0.07,-1.17 -0.49,-1.43 -0.42,-0.19 -3.02,-0.01 -3.74,-0.08 -0.07,-0.73 0.06,-3.22 -0.03,-3.61 -0.17,-0.66 -0.8,-0.62 -1.22,-0.62l-3.64 0c-0.55,0 -1.28,-0.11 -1.61,0.22 -0.38,0.39 -0.27,0.87 -0.27,1.55 0,0.62 -0.01,1.24 0,1.85 -0.48,-0.15 -0.53,-0.21 -1.1,-0.31 -1.38,-0.23 -2.69,0.14 -3.74,0.98 -0.14,0.12 -0.21,0.22 -0.35,0.34 -0.17,0.15 -0.46,0.56 -0.59,0.8 -1.58,2.92 0.23,6.27 3.36,6.55 0.78,0.06 1.41,0 2.14,-0.25 0.09,-0.03 0.17,-0.07 0.28,-0.09 0,0.73 0,1.47 0,2.2 0,0.53 -0.07,0.95 0.36,1.25 0.16,0.11 0.27,0.09 0.42,0.16z"
        />
        <path
          class="fil0"
          d="M17.83 61.08l1.22 0c-0.05,-0.35 -0.22,-0.66 -0.6,-0.68 -0.39,-0.01 -0.57,0.32 -0.62,0.68z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconInformatizaAps',
}
</script>

<style></style>
